export const logUser = (email: string) => {
  if (window?.dtrum) {
    window?.dtrum?.identifyUser(email);
  }
};

export const logError = (error: Error) => {
  if (window?.dtrum) {
    window?.dtrum?.reportError(error);
  }
};
